import { QTextEdit } from "./QTextEdit.js";
import { QCmd } from "./QCmd.js";

export class QListeningTextEdit extends QTextEdit {
  constructor() {
    super();
    this.fActiveSelection = true;
  }

  SetCmdCode(cmdCode) {
    this.fTECommandCode = cmdCode;
  }

  DoAfterKeyPress(keyInfo) {
    var commandCode = this.fTECommandCode ? this.fTECommandCode : "TEKeyPress";
    this.AddCmdParameter("keyInfo", keyInfo);
    var listenCommand = new QCmd();
    listenCommand.InitCommand(
      commandCode,
      this,
      this.fParentPanel,
      this.fParentPanel.fWSMgr,
      this.fDoc
    );
    this.SetCmdParameters(listenCommand);
    //Sending key info here in case we want it later.
    this.fParentPanel.ExecuteCommand(listenCommand);
  }

  InsertField(aCmd) {
    var newVal = "[" + aCmd["newvalue"] + "]";
    var val = aCmd["newvalue"];
    this.SetInsertAtEnd();
    this.InsertString(newVal);
    this.SelectFieldDefText(val);
    this.fParentPanel.TestFilter();
  }

  InsertFieldValue(aCmd) {
    var newObject = aCmd["fSourceElement"];
    var newVal = '"' + newObject["fName"] + '"';
    this.SetInsertAtEnd();
    this.InsertString(newVal);
    this.fParentPanel.TestFilter();
  }
}
